// frontend/src/pages/Home.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';
import Header from "../components/Header";
import StarBackground from "../components/StarBackground";
import redPlanet from '../assets/hiding/hiding-planet-red.png';
import bluePlanet from '../assets/hiding/hiding-planet-blue.png';
import greenPlanet from '../assets/hiding/hiding-planet-green.png';
import greyPlanet from '../assets/hiding/hiding-planet-grey.png';
import purplePlanet from '../assets/hiding/hiding-planet-purple.png';
import orangePlanet from '../assets/hiding/hiding-planet-orange.png';
import brownPlanet from '../assets/hiding/hiding-planet-brown.png';
import Character from "../components/Character";
import {getTranslation} from '../config/translations';
import PlanetsBackground from "../components/PlanetsBackground";
import { AppContext } from '../contexts/AppContext';

export default function Home() {
    const navigate = useNavigate();
    const [showBanner, setShowBanner] = useState(false);
    const { startBgMusic } = useContext(AppContext);
    
    useEffect(() => {
        // Avvia la musica tramite il contesto globale
        startBgMusic();

        // Listener per sbloccare l'autoplay su interazione (necessario per molti browser)
        const handleInteraction = () => {
            startBgMusic();
            document.removeEventListener('click', handleInteraction);
            document.removeEventListener('touchstart', handleInteraction);
        };

        document.addEventListener('click', handleInteraction);
        document.addEventListener('touchstart', handleInteraction);
        
        return () => {
            document.removeEventListener('click', handleInteraction);
            document.removeEventListener('touchstart', handleInteraction);
        };
    }, [startBgMusic]);

    const handleStart = () => {
        navigate('/login');
    };
    
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('selectedLanguage') || 'it');
    const translations = getTranslation(currentLanguage);
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBanner(true);
        }, 3000);
        
        const handleLanguageChange = () => {
            const newLanguage = localStorage.getItem('selectedLanguage') || 'it';
            if (newLanguage !== currentLanguage) {
                setCurrentLanguage(newLanguage);
            }
        };
        
        const interval = setInterval(handleLanguageChange, 500);
        
        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [currentLanguage]);
    
    return (
        <div className="home-wrapper">
            <Header />
            
            <div className="planet-background" onClick={handleStart}>
                <PlanetsBackground />
                
                <img src="/assets/images/home/Title.png" alt="Mars Title" className="title" />
                <img src="/assets/images/home/Subtitle.png" alt="Mars Subtitle" className="title subtitle" onClick={handleStart}/>
                
                {showBanner && (
                    <div className="blinking-banner" onClick={handleStart}>
                        {translations.homeBanner}
                    </div>
                )}
                <Character name="Mars" position="left"/>
            </div>
        </div>
    );
}
